import { getCSRFToken } from '/app/app/assets/js/utils/security.js'
import { flashInfo, flashFailure } from '/app/app/assets/js/utils/flash.js'
import { parseRawHtmlPart } from '/app/app/assets/js/utils/dom-parser.js'

export default (url, name, method, i18n) => ({
  xhr: null,
  progress: 0,
  touched: false,
  busy: false,
  started: null,

  init() {
    this.$refs.fileInput && (this.$refs.fileInput.value = '')
    this.progress = 0
    this.started = null
    this.xhr = new XMLHttpRequest()
  },

  start() {
    if (this.started) return
    if (this.validate()) this.upload()
  },

  validate() {
    if (this.$refs.fileInput.files.length == 0) {
      flashFailure(i18n.select_at_least_one_file)
      return false
    }

    return true
  },

  upload() {
    this.xhr.open(method.toUpperCase(), url, true)
    this.xhr.setRequestHeader('X-CSRF-Token', getCSRFToken())
    this.xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    this.xhr.upload.onprogress = this._updateProgress.bind(this)
    this.xhr.onload = this._finalize.bind(this)
    this.xhr.send(this._gather(this.$refs.fileInput.files))
    this.started = new Date().getTime()
  },

  cancel() {
    this.xhr.abort()
    this.init()
    flashInfo(i18n.upload_canceled)
  },

  _gather(files) {
    const formData = new FormData()
    for (let i = 0; i < files.length; i++) formData.append(name, files[i])
    return formData
  },

  _updateProgress(e) {
    if (e.lengthComputable) this.progress = (e.loaded / e.total) * 90
    if (this.progress < 90) return

    const step = (new Date().getTime() - this.started) / 1500
    this._fakeProgress(10 / step)
  },

  _fakeProgress(step) {
    if (this.progress >= 100) return

    this.progress = Math.min(this.progress + step, 100)
    setTimeout(() => this._fakeProgress(step), 1000)
  },

  _finalize() {
    if (this.xhr.status === 200) {
      const oldTurboFrame = this.$root.closest('turbo-frame')
      const newTurboFrame = parseRawHtmlPart(
        this.xhr.responseText,
        `#${oldTurboFrame.id}`,
      )
      oldTurboFrame.replaceWith(newTurboFrame)
    } else flashFailure(i18n.upload_failed_with_status + this.xhr.status)
  },
})
